import { LatestPromotion, PagedPromotion, Promotion } from "@models";
import { promotionService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class PromotionStore {
  promotions: Promotion[] = [];
  latest: LatestPromotion[] = [];
  loading = false;
  latestLoading = false;

  // Dedicated /promotions page (paged)
  active: LatestPromotion[] = [];
  activeTotalCount = 0;
  activeSkipCount = 0;
  activeMaxResultCount = 12;
  activeLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (tenantId: number) => {
    this.setLoading(true);
    try {
      const promotions = await promotionService.getAll(tenantId);
      runInAction(() => {
        this.promotions = promotions;
      });
      this.setLoading(false);
    } catch (error) {
      console.error(error);
      this.reset();
      this.setLoading(false);
    }
  };

  getLatest = async (count = 6) => {
    runInAction(() => {
      this.latestLoading = true;
    });
    try {
      const latest = await promotionService.getLatest(count);
      runInAction(() => {
        this.latest = latest;
        this.latestLoading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.latest = [];
        this.latestLoading = false;
      });
    }
  };

  getActive = async (request: PagedPromotion) => {
    runInAction(() => {
      this.activeLoading = true;
    });
    try {
      const response = await promotionService.getActive(request);
      runInAction(() => {
        this.active = response.items;
        this.activeTotalCount = response.totalCount;
        this.activeLoading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.active = [];
        this.activeLoading = false;
      });
    }
  };

  setActiveSkipCount = (value: number) => {
    this.activeSkipCount = value;
  };

  handleActivePageChange = (page: number) => {
    this.activeSkipCount = (page - 1) * this.activeMaxResultCount;
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  reset = () => {
    runInAction(() => {
      this.promotions = [];
    });
  };
}
